import { Navigate, Outlet } from 'react-router-dom';
import RegistrationUnavailable from './RegistrationUnavailable';
import { useSaasSession } from './session';

interface SaasEntryGateProps {
  registrationRequired?: boolean;
}

/**
 * SaaS public entries must never activate on a single-tenant enterprise deployment.
 * The backend owns this mode decision so the UI cannot infer it from a missing route.
 */
export function SaasEntryGate({ registrationRequired = false }: SaasEntryGateProps) {
  const sessionQuery = useSaasSession();

  if (sessionQuery.isLoading) return null;
  if (sessionQuery.isError || !sessionQuery.data) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-background px-4">
        <p className="text-sm text-foreground/60">暂时无法确认工作空间入口，请稍后重试。</p>
      </main>
    );
  }

  if (sessionQuery.data.deploymentMode !== 'saas') {
    return <Navigate to="/login" replace />;
  }

  if (registrationRequired && !sessionQuery.data.registrationEnabled) {
    return <RegistrationUnavailable />;
  }

  return <Outlet />;
}
